/**
 * Medical Files Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import AppConfig from "../../../constants/AppConfig";

// States
const state = {
    files: [],
    file: {},
    teleconsultations: {},
    bulletins: {},
    bons: {},
    prescriptionImageries: {}
};

// Getters
const getters = {
    files: state => {
        return state.files
    },

    file: state => {
        return state.file
    },

    teleconsultations: state => {
        return state.teleconsultations
    },

    bulletins: state => {
        return state.bulletins
    },

    bons: state => {
        return state.bons
    },

    prescriptionImageries: state => {
        return state.prescriptionImageries
    }
};

// Actions
const actions = {
    getMedicalFiles(context, payload) {
        function successCallback(response) {
            context.commit('getMedicalFilesHandler', { files: response.data.dossiers });
            context.commit('getPatientHandler', { patient: {} });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.MedicalFile.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    addDoctorToPatient(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.MedicalFile.MedecinPatient, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    deleteMedecinPatient(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.MedicalFile.DeleteMedecinPatient, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getMyMedicalFile(context, payload) {
        function successCallback(response) {
            context.commit('getMyMedcialFilesHandle', { files: response.data.dossiers });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.MedicalFile.My, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getSearchMyMedicalFile(context, payload) {
        function successCallback(response) {
            context.commit('getMyMedcialFilesHandle', { files: response.data.dossiers });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        return makeApiRequest(payload.args, apiModel.MedicalFile.MySearch, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getMedicalFile(context, payload) {
        function successCallback(response) {
            context.commit('getMedicalFileHandler', { file: response.data.dossier });
            //Mise a jour de
            let patient = [];
                patient = response.data.dossier.patient;
                patient['dossier']= [];
                patient['dossier']['numero_dossier'] = response.data.dossier.numero_dossier;
            context.commit('getPatientHandler', { patient: patient });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.MedicalFile.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    printMedicalFile(context, payload) {
        function successCallback(response) {
            let url= AppConfig.imgUrl+'/public/storage/pdf/'+response.data.name;
            let fileName = response.data.name;
            Vue.axios.get(
                url,{
                    responseType: 'blob', // important
                }
            ).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');
        // let url= 'http://localhost:8000/public/storage/pdf/invoice.pdf';
        // Vue.axios.get(
        //     url,{
        //         responseType: 'blob', // important
        //     }
        // ).then((response) => {
        //     const url = window.URL.createObjectURL(new Blob([response.data]));
        //     const link = document.createElement('a');
        //     link.href = url;
        //     link.setAttribute('download', 'file.pdf');
        //     document.body.appendChild(link);
        //     link.click();
        // });

        makeApiRequest(payload.args, apiModel.MedicalFile.Print, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createMedicalFile(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'medical-files' });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.MedicalFile.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateMedicalFile(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'medical-files' });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.MedicalFile.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteMedicalFile(context, payload) {
        function successCallback(response) {
            context.commit('deleteMedicalFileHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.MedicalFile.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getTeleconsultations(context, payload){

        function successCallback(response) {

            context.commit('getTeleconsultationsHandler', { teleconsultations: response.data });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, {"method" : "GET", "url" : "/v2/teleconsultations/patient/"+payload.args.patient_id}, localToken, successCallback, errorCallback, payload.errorMessages);

    },

    getBulletins(context, payload){
        function successCallback(response) {
            context.commit('getBulletinsHandler', { bulletins: response.data });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, {"method" : "GET", "url" : "/v2/examen_analyses/patient/"+payload.args.patient_id}, localToken, successCallback, errorCallback, payload.errorMessages);
        // +payload.args.patient_id
    },

    getBonPriseCharge(context, payload){

        function successCallback(response) {
            context.commit('getBonsHandler', { bons: response.data });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, {"method" : "GET", "url" : "/v2/bon_prises_en_charges/patient/"+payload.args.patient_id}, localToken, successCallback, errorCallback, payload.errorMessages);
        // +payload.args.patient_id
    },

    getPrescriptionImagerie(context, payload){

        function successCallback(response) {
            context.commit('getPrescriptionImagerieHandler', { prescriptionImageries: response.data });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, {"method" : "GET", "url" : "/v2/prescription_imageries/patient/"+payload.args.patient_id}, localToken, successCallback, errorCallback, payload.errorMessages);
        // +payload.args.patient_id
    }
};

// Mutations
const mutations = {
    getMedicalFilesHandler(state, { files }) {
        // Update files state
        state.files = files;
    },
    getMyMedcialFilesHandle(state, { files }) {
        // Update patients state
        state.files = files;
    },
    getMedicalFileHandler(state, { file }) {
        // Update file state
        state.file = file;
    },

    deleteMedicalFileHandler(state, { index, successMessage }) {
        let i = state.files.findIndex(file => file.slug === index);

        if (~i) {
            state.files.splice(i, 1);

            router.push({ name: 'medical-files' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    },
    getTeleconsultationsHandler(state, { teleconsultations }) {
        // Update teleconsultations state
        state.teleconsultations = teleconsultations;
    },
    getBulletinsHandler(state, { bulletins }){
        // Update bulletins state
        state.bulletins = bulletins;
    },
    getBonsHandler(state, { bons }){
        // Update bon prise en charge state
        state.bons = bons;
    },
    getPrescriptionImagerieHandler(state, { prescriptionImageries }){
        // Update prescriptionImageries state
        state.prescriptionImageries = prescriptionImageries;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}